var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sku-bluk",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _vm.field == "Case" || _vm.field == "Weight" || _vm.field == "Inventory"
        ? [
            _c("el-input", {
              attrs: {
                placeholder: _vm._f("disPlaceholder")(_vm.field),
                oninput:
                  "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>10000){value=10000}"
              },
              model: {
                value: _vm.enterValue,
                callback: function($$v) {
                  _vm.enterValue = $$v
                },
                expression: "enterValue"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.enterValue,
                    expression: "!enterValue"
                  }
                ],
                staticClass: "required-error"
              },
              [_vm._v("Please enter")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.field == "FOB Price" ||
      _vm.field == "Cost Price" ||
      _vm.field == "Procurement Price" ||
      _vm.field == "Wholesale Settlement Price" ||
      _vm.field == "Retail Price" ||
      _vm.field == "Wholesale Price"
        ? [
            _c(
              "el-input",
              {
                staticClass: "input-with-select",
                staticStyle: { width: "220px" },
                attrs: {
                  placeholder: "0.00",
                  oninput:
                    "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                },
                model: {
                  value: _vm.enterValue,
                  callback: function($$v) {
                    _vm.enterValue = $$v
                  },
                  expression: "enterValue"
                }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { slot: "prepend", placeholder: "Please Select" },
                    slot: "prepend",
                    model: {
                      value: _vm.operator,
                      callback: function($$v) {
                        _vm.operator = $$v
                      },
                      expression: "operator"
                    }
                  },
                  [
                    _c("el-option", { attrs: { label: "+", value: "+" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "-", value: "-" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "*", value: "*" } })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.enterValue,
                    expression: "!enterValue"
                  }
                ],
                staticClass: "required-error"
              },
              [_vm._v("Please enter")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.field == "Dimensions"
        ? [
            _c(
              "div",
              { staticClass: "dimensions-info" },
              [
                _c("el-input", {
                  staticStyle: { width: "70px" },
                  attrs: {
                    oninput:
                      "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')} if(value>1000){value=1000}",
                    placeholder: "L (cm)"
                  },
                  model: {
                    value: _vm.length,
                    callback: function($$v) {
                      _vm.length = $$v
                    },
                    expression: "length"
                  }
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "70px" },
                  attrs: {
                    oninput:
                      "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>1000){value=1000}",
                    placeholder: "W (cm)"
                  },
                  model: {
                    value: _vm.width,
                    callback: function($$v) {
                      _vm.width = $$v
                    },
                    expression: "width"
                  }
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "70px" },
                  attrs: {
                    oninput:
                      "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>1000){value=1000}",
                    placeholder: "H (cm)"
                  },
                  model: {
                    value: _vm.height,
                    callback: function($$v) {
                      _vm.height = $$v
                    },
                    expression: "height"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.length || !_vm.width || !_vm.height,
                    expression: "!length||!width||!height"
                  }
                ],
                staticClass: "required-error"
              },
              [_vm._v("Please enter")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.field == "Availability"
        ? [
            _c(
              "el-select",
              {
                staticStyle: { width: "160px", padding: "5px 5px 2px" },
                attrs: { placeholder: "Please Select" },
                on: { change: _vm.changeStatus },
                model: {
                  value: _vm.enterValue,
                  callback: function($$v) {
                    _vm.enterValue = $$v
                  },
                  expression: "enterValue"
                }
              },
              _vm._l(_vm.skuStatusOptions, function(item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value }
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.enterValue == "0"
              ? _c("el-date-picker", {
                  staticStyle: { "margin-top": "5px", width: "160px" },
                  attrs: {
                    type: "date",
                    "value-format": "MM/dd/yyyy",
                    placeholder: "MM/DD/YYYY",
                    format: "MM/dd/yyyy"
                  },
                  model: {
                    value: _vm.batchRestockDate,
                    callback: function($$v) {
                      _vm.batchRestockDate = $$v
                    },
                    expression: "batchRestockDate"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.goodsStatusDb == "0",
                    expression: "goodsStatusDb=='0'"
                  }
                ],
                staticClass: "required-error"
              },
              [_vm._v("Please set SPU Active first")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (!_vm.enterValue ||
                        (_vm.enterValue == "0" && !_vm.batchRestockDate)) &&
                      _vm.goodsStatusDb !== "0",
                    expression:
                      "(!enterValue || (enterValue=='0' && !batchRestockDate)) && goodsStatusDb!=='0'"
                  }
                ],
                staticClass: "required-error"
              },
              [_vm._v("Please Select")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "btn", on: { click: _vm.submit } }, [
        _vm._v("Bluk Set")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92ba2254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92ba2254","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/spuDetails/sku-bluk-set.vue
// module id = TTkP
// module chunks = 2